const options = {
  height: "100%",
  // virtualDomBuffer: 300,
  placeholder: "No Data Available",
  movableRows: true,
  pagination: "local",
  paginationSize: 5,
  selectable: 1,
  tooltips: true,
  tooltipsHeader: true,
  tooltipGenerationMode: "hover",
  layout: "fitColumns",
  downloadConfig: {
    columnGroups: false, //include column groups in column headers for download
    rowGroups: false, //do not include row groups in download
    columnCalcs: false, //do not include column calculation rows in download
    dataTree: false, //do not include data tree in download
  },
  downloadReady: (fileContents, blob) => blob,
  cellEdited: function (cell) {
    // $.ajax({
    //   url: "server.php",
    //   method: "post",
    //   data: { data: cell },
    //   success: function () {},
    // });
  },
};

export default {
  options,
};
